// Establishes `window.jQuery` / `window.$` before any sibling import in main.js
// evaluates. Must be the first import in main.js.
//
// Assignment is guarded by a nullish check: if flex.min.js loaded earlier in the
// page, its jQuery instance (with jquery-placeholder / jquery-validation
// plugins registered) already occupies window.jQuery. Overwriting
// it here with main.min.js's separately-bundled jQuery would strip those plugins.
// When only main.min.js is loaded (no flex-forms on the page), the `??=` falls
// back to the local copy so downstream code still has a working `$`.
import $ from 'jquery';

window.jQuery ??= $;
window.$ ??= $;
